define('companiesListFiltersQuickAccessView',[
  'module',
  'app',
  'underscore',
  'bootbox',
  'imageUtils',
  'filtersBannerQuickAccessView',
  'template!companiesListFiltersQuickAccessView'
], function (
  Module,
  App,
  _,
  Bootbox,
  ImageUtils,
  QuickAccessView,
  Tpl
) {
  'use strict';

  Module.exports = QuickAccessView.extend({
    template: Tpl,
    className: 'companies-list-filters-quick-access-view ' + QuickAccessView.prototype.className,

    ui: _.extend({}, QuickAccessView.prototype.ui, {
      name: '.js-qa-name',
      emailDomain: '.js-qa-domain',
      countryCode: '.js-qa-country',
      exportButton: '.js-qa-export',
      importButton: '.js-qa-import',
      fileInput: '.js-qa-file'
    }),

    events: _.extend({}, QuickAccessView.prototype.events, {
      'change @ui.name': 'onNameChange',
      'change @ui.emailDomain': 'onDomainChange',
      'change @ui.countryCode': 'onCountryChange',
      'click @ui.exportButton': 'onExport',
      'click @ui.importButton': 'onImportClick',
      'change @ui.fileInput': 'onImportFile'
    }),

    modelEvents: {
      'change:name': 'onRender',
      'change:emailDomain': 'onRender',
      'change:countryCode': 'onRender'
    },

    initialize: function () {
      this.tableView = this.options.bannerView.options.tableView;
    },

    onRender: function () {
      this.ui.name.val(this.model.get('name') || '');
      this.ui.emailDomain.val(this.model.get('emailDomain') || '');
      this.ui.countryCode.val(this.model.get('countryCode') || '');
    },

    onNameChange: function () {
      this.model.set('name', this.ui.name.val().trim());
      this.trigger('confirm', this.model);
    },

    onDomainChange: function () {
      this.model.set('emailDomain', this.ui.emailDomain.val().trim());
      this.trigger('confirm', this.model);
    },

    onCountryChange: function () {
      this.model.set('countryCode', this.ui.countryCode.val().trim());
      this.trigger('confirm', this.model);
    },

    // Export every company matching the filters/sort currently applied to the table.
    onExport: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var params = {};
      var filters = this.tableView && this.tableView.filters;
      if (filters) {
        if (filters.get('name')) { params.name = filters.get('name'); }
        if (filters.get('emailDomain')) { params.emailDomain = filters.get('emailDomain'); }
        if (filters.get('countryCode')) { params.countryCode = filters.get('countryCode'); }
      }
      if (this.tableView) {
        params.sidx = this.tableView.sortField;
        params.sord = this.tableView.sortDirection;
      }

      window.open(App.request('companies:export-url', params), '_self');
    },

    onImportClick: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.ui.fileInput.trigger('click');
    },

    // Read the chosen .xlsx, base64-encode it and POST it; refresh the table on success.
    onImportFile: function (e) {
      e.stopPropagation();
      if (!e.target || !e.target.files || !e.target.files[0]) {
        return;
      }

      var fileInfo = ImageUtils.getFileInfo(e.target, 0);
      if (!fileInfo) {
        return;
      }

      ImageUtils.encodeInputFileToBase64(e.target, 0, _.bind(function (bytes) {
        this.ui.fileInput.val('');
        if (!bytes) {
          return;
        }
        fileInfo.base64Value = bytes;
        App.request('companies:upload-excel', fileInfo).done(_.bind(function (resp) {
          if (this.tableView) {
            this.tableView.bodyView.fetch();
            if (this.tableView.footerView) {
              this.tableView.footerView.fetch();
            }
          }
          var updated = resp && resp.updated ? resp.updated : 0;
          var skipped = resp && resp.skipped ? resp.skipped : 0;
          Bootbox.alert(_.i18n('companies.import.done', null, 'Import done.') +
            ' (' + updated + ' updated, ' + skipped + ' skipped)');
        }, this)).fail(function () {
          Bootbox.alert(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
        });
      }, this));
    }
  });
});

